import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

/*
* Widgets are tools/windows that can be added to the mosaic layout. There are two types of widgets:
* 1/ TreeWidgetType: Widgets that are specific to the scenario tree on the operation page
* 2/ ToolWidgetType: Widgets that are specific to the top toolbar
*/
export const TREE_WIDGETS = {
  Inbox: "Inbox",
  PlanningShiftTable: "PlanningShiftTable",
  ScenarioSummaryTable: "ScenarioSummaryTable",
  ScenarioUnassignedOrders: "ScenarioUnassignedOrders",
  RunsheetShiftTable: "RunsheetShiftTable",
  RunsheetUnassignedOrders: "RunsheetUnassignedOrders",
  RunsheetSummaryTable: "RunsheetSummaryTable",
} as const
export type TreeWidgetType = keyof typeof TREE_WIDGETS

export const TOOL_WIDGETS = {
  Map: "Map",
  Violations: "Violations",
  Geocode: "Geocode",
  GanttChart: "GanttChart",
  A2BRoute: "A2BRoute",
  Solver: "Solver",
  RunsheetBreaks: "RunsheetBreaks",
} as const
export type ToolWidgetType = keyof typeof TOOL_WIDGETS;

export type WidgetType = ToolWidgetType | TreeWidgetType

/*
* WidgetTypeWithSuffix is a unique identifier for each widget. It is a combination of the widget type and a unique suffix.
*/
export type WidgetTypeWithSuffix = `${ToolWidgetType | TreeWidgetType}-${string}`


/*
* WidgetNode defines the relevant information to spawn a widget to the top toolbar
*/
export type WidgetNode = {
  icon: IconDefinition
  tooltip: string
  description?: string
  widgetType: ToolWidgetType
  name: string
  location: 'mosaic' | 'toolbar' | 'hidden' // Whether the widget is in the mosaic layout, top toolbar, or hidden
}
